import { useEffect } from "react";
import { BrowserRouter } from "react-router-dom";
import AppRoutes from "./routes/AppRoutes";
import { AuthProvider } from "./context/AuthContext";
import { ThemeProvider } from "./context/ThemeContext";
import { API_CONFIG } from "./utils/apiConfig";

function App() {
  useEffect(() => {
    if (API_CONFIG.isDemo) {
      document.title = "ANAXISTECH";

      const iconPng = document.querySelector("link[rel='icon'][type='image/png']");
      if (iconPng) {
        iconPng.href = "/logo/demo/anaxis-favicon.png";
      }
      const iconSvg = document.querySelector("link[rel='icon'][type='image/svg+xml']");
      if (iconSvg) {
        iconSvg.href = "/logo/demo/anaxis-favicon.png";
      }
    }
  }, []);

  return (
    <ThemeProvider>
      <AuthProvider>
        <BrowserRouter>
          <AppRoutes />
        </BrowserRouter>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
